export default __webpack_public_path__ + "static/media/Arquivo de Pedidos.7eebbdd1.svg";